import { useQuery } from '@tanstack/react-query';
import { cartService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { convertGoodsLikeItemToGoodsData } from '../../PostGoodsActionBottomSheet/utils/convertGoodsLikeItemToGoodsData';

export const useCartAddRecommend = () => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: queryKey.goodsCartRecommend(goodsSno),
    queryFn: () => cartService.getAddCartRecommend(goodsSno),
    select: data => {
      return {
        ...data,
        carousels: data.carousels.map(carousel => {
          return {
            ...carousel,
            item_list: carousel.item_list.map(convertGoodsLikeItemToGoodsData),
          };
        }),
      };
    },
  });
};
